import {ValueType} from '@/api/meta/filters';
import {ApiSortOrder, ApiSortsDerived} from '@/api/meta/odata';
import {getContactHistories} from '@/api/module/contactHistory';
import ContactHistory, {
  ApiContactHistory,
  ContactHistoryFilters,
} from '@/model/ContactHistory';
import {
  createVersionedStorage,
} from './types';
import {boolToDisplay, fulltextToDisplay} from '@/util/store';

// const filterNames: Record<keyof ContactHistoryFilters, string | null> = {
//   Fulltext$Fulltext: 'Suche',
//   KundenNr: 'Kunden-Nr.',
//   Erledigt: null,
//   Art$In: 'Art',
//   Ansprechpartner$Any: 'Ansprechpartner',
// };

export type ContactHistoryStore = ReturnType<typeof useContactHistoryStore>

export const useContactHistoryStore = createVersionedStorage<
  ContactHistoryFilters,
  ApiSortsDerived<ApiContactHistory>,
  ContactHistory[]
>('contactHistories', {
  fetchFn: getContactHistories,
  formatter: {
    // everything is hidden by default. display object has to be created explicitly
    Erledigt: boolToDisplay('Erledigt', 'Offen'),
    Fulltext$Fulltext: fulltextToDisplay,
    Art$In(val) {
      if (val) {
        return val.map((value, indx) => ({text: `Art: ${value}`, keypath: [indx.toString()]}));
      }
    },
  },
  // Old way for comparison:
  // convertFilterToDisplayFn: createConvertFiltersToDisplayFn(
  //     createGetRowFn({
  //       getLabel: ({actualKeys}) => {
  //         return filterNames[actualKeys.index as keyof ContactHistoryFilters];
  //       },
  //       isHidden: ({actualKeys}) => actualKeys.index === 'KundenNr' || actualKeys.index === 'Ansprechpartner$Any',
  //     }),
  // ),
  defaultData: [],
  defaultFilters: {
    Fulltext$Fulltext: {
      words: [],
      fields: [
        {
          path: ['Bediener', 'Bediener'],
          valueType: ValueType.StringContains,
        },
        {
          path: ['Thema'],
          valueType: ValueType.StringContains,
        },
      ],
    },
  },
  defaultLimit: 10,
  defaultSorts: [['AnlageDatum', ApiSortOrder.Desc]],
});
